<div class="onboarding-container">
  <!-- Logo Section -->
  <div class="logo-section">
    @if (carrierData?.companyLogo) {
      <div class="carrier-logo-box">
        <img [src]="carrierData?.companyLogo" alt="Carrier Logo" />
      </div>
    } @else {
      <div class="ellipse-icon">
        <img src="/assets/images/fleetoperate.png" alt="FleetOperate Logo" />
      </div>
    }

  </div>

  <!-- Welcome Text -->
  <div class="welcome-text">
    <h1>Welcome to <strong>{{ carrierData?.companyName || 'POSITIVE TRUCKING INC.' }}</strong></h1>
  </div>

  <!-- Get Started Button -->
  <div class="action-section">
    <button class="get-started-btn" (click)="onGetStarted()">
      Get Started to apply
    </button>
  </div>

  <!-- Pagination Dots -->
  <div class="pagination-dots">
    <div class="dot active"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</div>
